export const login_msg = {
    emailError: '올바르지 않은 이메일 형식 입니다',

    telError: '-를 제외한 휴대전화번호 10자리 또는 11자리를 입력해주세요',

    passwordError: '최소 8자리 이상 비밀번호를 사용해주세요',
    passwordCheckError: '비밀번호가 일치하지 않습니다',

    nameError: '올바르지 않은 값입니다',
    nameMaxLengthError : '이름은 최대 40자까지 입력 가능합니다'

}

export const signup_msg = {
    existId: '이미 사용중인 아이디입니다',
    usableId: '사용 가능한 아이디입니다',
    certificationSuccess: '인증에 성공하였습니다',
    certificationFail: '인증에 실패하였습니다. 인증번호를 확인해주세요',
    certificationInValid: '인증번호 6자리를 입력해주세요',
    certificationExpired: '인증번호가 만료되었습니다. 인증번호 재전송을 클릭하여 새로운 인증번호를 입력해주세요',
}